'use client';

import { ServiceLayer } from '@packages/cms-components/src/modules/ServiceLayer/ServiceLayer';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { customerReviewsInfoCallToActionMessages } from './CustomerReviewsInfoCallToAction.messages';
import { useCustomerReviewsTracking } from '../Tracking/useCustomerReviewsTracking/useCustomerReviewsTracking';

/**
 * CustomerReviewsInfoCallToAction button and dialog with rating information
 */
export const CustomerReviewsInfoCallToAction = () => {
  const {
    product: {
      reviews: { hintLayerId },
    },
  } = useConfig();

  const [dialogOpened, setDialogOpened] = useState(false);
  const { formatMessage } = useIntl();
  const { trackInfoDisplayOverlay } = useCustomerReviewsTracking();

  const dialogTitle = formatMessage(customerReviewsInfoCallToActionMessages.title);

  const handleDialogOpen = () => {
    trackInfoDisplayOverlay(dialogTitle);
    setDialogOpened(true);
  };
  const handleDialogClose = () => {
    setDialogOpened(false);
  };

  return (
    <>
      {dialogOpened && (
        <Dialog isOpen={dialogOpened} title={dialogTitle} onClose={handleDialogClose}>
          <DialogHeader onClose={handleDialogClose}>{dialogTitle}</DialogHeader>
          <DialogContent>
            <ServiceLayer serviceLayerId={hintLayerId} />
          </DialogContent>
        </Dialog>
      )}
      <Button
        variant="icon-flat"
        size="small"
        onClick={handleDialogOpen}
        aria-label={formatMessage(customerReviewsInfoCallToActionMessages.ariaLabel)}
      >
        <span className="inline-block h-2 w-2">
          <span className="icon-emp-info-filled inline-block h-full w-full" />
        </span>
      </Button>
    </>
  );
};
